import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient, ConvertParamsToFormData } from "~/utils";

import { ResponseMessageType, RawDraftContentState } from "~/domains";

type RequestDataType = {
  knowledgeInsightPostId: string;
  body: {
    content: RawDraftContentState;
    attachFiles: File[];
    quotePostId?: string;
  };
};

const request = ({ knowledgeInsightPostId, body }: RequestDataType) => {
  const formData = ConvertParamsToFormData({ reply: body });
  return new ApiClient()
    .post<ResponseMessageType>(
      `/api/members/knowledge_insight_posts/${knowledgeInsightPostId}/knowledge_insight_post_comments`,
      formData,
    )
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisMembersKnowledgeInsightPostsKnowledgeInsightPostCommentsCreate =
  ({ options = {} }: PropsType = {}): UseMutationResult<
    ResponseMessageType,
    RequestDataType
  > => {
    return useMutation(request, { ...options });
  };
